import { Typography } from "@suraasa/placebo-ui"

type Props = {
  data?: {
    error: unknown
    componentStack: string
    eventId: string
    resetError(): void
  }
  errorStatus?: 404 | 500 | 401
  title?: string
  description?: string
  render?: () => React.ReactNode
}

export default function ErrorPage({
  data,
  errorStatus,
  title = "Page not found!",
  description = "We couldn't find the page you're looking for.",
  render,
}: Props) {
  if (data) console.error(`> Error Captured: ${data.error}`)

  if (errorStatus && errorStatus === 401) {
    return (
      <div className="flex min-h-[calc(100vh_-_65px)] flex-col items-center justify-center px-4 text-center">
        <div>
          {/* Logo */}
          <div className="mb-8">
            <img
              src="https://assets.suraasa.com/logos/v2/mini.webp"
              alt="Suraasa"
              width={80}
              height={80}
              className="mx-auto"
            />
          </div>

          {/* Error Message */}
          {render ? (
            <div>{render()}</div>
          ) : (
            <div className="space-y-1">
              <Typography variant="title1">Unauthorized</Typography>
              <Typography className="mx-auto max-w-md text-muted">
                You don't have access to view this page.
              </Typography>
            </div>
          )}
        </div>
      </div>
    )
  }
  if (errorStatus && errorStatus === 404) {
    return (
      <div className="flex min-h-[calc(100vh_-_65px)] flex-col items-center justify-center px-4 text-center">
        <div>
          {/* Logo */}
          <div className="mb-8">
            <img
              src="https://assets.suraasa.com/logos/v2/mini.webp"
              alt="Suraasa"
              width={80}
              height={80}
              className="mx-auto"
            />
          </div>

          {/* Error Message */}
          {render ? (
            <div>{render()}</div>
          ) : (
            <div className="space-y-1">
              <Typography variant="title1">{title}</Typography>
              <Typography className="mx-auto max-w-md text-muted">
                {description}
              </Typography>
            </div>
          )}
        </div>
      </div>
    )
  }
  if (errorStatus && errorStatus >= 500) {
    return (
      <div className="flex min-h-[calc(100vh_-_65px)] flex-col items-center justify-center px-4 text-center">
        <div>
          {/* Logo */}
          <div className="mb-8">
            <img
              src="https://assets.suraasa.com/logos/v2/mini.webp"
              alt="Suraasa"
              width={80}
              height={80}
              className="mx-auto"
            />
          </div>

          {/* Error Message */}
          {render ? (
            <div>{render()}</div>
          ) : (
            <div className="space-y-1">
              <Typography variant="title1">Something went wrong</Typography>
              <Typography className="mx-auto max-w-md text-muted">
                Something unexpected occurred in our system. We&apos;re looking
                into it. 🤔
              </Typography>
            </div>
          )}
        </div>
      </div>
    )
  }

  return (
    <div className="flex min-h-[calc(100vh_-_65px)] flex-col items-center justify-center px-4 text-center">
      <div>
        {/* Logo */}
        <div className="mb-4">
          <img
            src="https://assets.suraasa.com/logos/v2/mini.webp"
            alt="Suraasa"
            width={80}
            height={80}
            className="mx-auto"
          />
        </div>

        {/* Error Message */}
        {render ? (
          <div>{render()}</div>
        ) : (
          <div className="space-y-1">
            <Typography variant="title1">Something went wrong</Typography>
            <Typography className="mx-auto max-w-md text-muted">
              Something unexpected occurred in our system. We&apos;re looking
              into it. 🤔
            </Typography>
          </div>
        )}
      </div>
    </div>
  )
}
